import React from "react";
import { useMediaQuery } from "@mui/material";
import Header from "../../global/Header";
import { ReactComponent as GroupLogo } from "../../data/svg/6334.svg";
import { ReactComponent as AnalyticsLogo } from "../../data/svg/6A.svg";
import { ReactComponent as AcademyLogo } from "../../data/svg/6334Academy.svg";
import DreamSlider from "../../components/DreamSlider";
import FlashingSentence from "../../components/FlashingSentence";
import Section from "../../components/Section";
import Heading from "../../components/Heading";
import Essay from "../../components/Essay";
import Slider from "../../components/Slider";
import CardList from "../../components/CardList";
import ButtonBar from "../../components/ButtonBar";
import LogoSlider from "../../components/LogoSlider";
import {
  dark,
  light,
  logos,
  competences,
  sentences,
  buildings,
  designBarButtons,
  value,
  endButtons,
  teamButtons,
  servicesButtons,
  homeAboutHeading,
  homeAboutEssay,
  homeValueHeading,
  homeValueEssay,
  homeCompetenciesHeading,
  homeCompetenciesEssay,
  homeClientHeading,
  homeClientEssay,
  homeConclusionEssay,
  isTabWidth,
  menuItems,
} from "../../data/database";
import { useResponsiveFontSize } from "../../functions";
import { customColour } from "../../data/colour";
import Footer from "../../global/Footer";

const linkLogo = [
  {
    label: "Academy",
    LinkLogoSvg: AcademyLogo,
    link: "/academy/home",
  },
  {
    label: "Analytics",
    LinkLogoSvg: AnalyticsLogo,
    link: "/analytics/home",
  },
];

const GroupHome = () => {
  const isTab = useMediaQuery(isTabWidth);
  return (
    <>
      {/* MOTION ENGAGE */}
      <DreamSlider
        images={buildings}
        buttons={designBarButtons}
        gap={isTab ? "0.75rem" : "2rem"}
        titleFontSize={isTab ? "1.5rem" : "3rem"}
        textFontSize={useResponsiveFontSize()}
        textLeft={isTab ? "50%" : "10%"}
        textWidth={isTab ? "70%" : "40%"}
        transform={isTab ? "translate(-50%, -50%)" : "translate(0, -50%)"}
      />

      {/* GREETING Light*/}
      <Section
        backgroundColor={customColour.lightBackground}
        width={isTab ? "95%" : "70%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <FlashingSentence
          sentences={sentences}
          interval={7500}
          mainTextColor={customColour.lightBlue}
          mainTextSize={isTab ? "1rem" : "1.5rem"}
          subTextSize={isTab ? "0.7rem" : "0.75rem"}
        />
      </Section>

      {/* ABOUT US Light*/}
      <Section
        backgroundColor={customColour.lightBackground}
        image={light}
        color={customColour.black}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
        // borderTop={`1.5px solid ${customColour.darkBackground}`}
      >
        <Heading
          heading={homeAboutHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "200" : "200"}
        />
        <Essay
          paragraphs={homeAboutEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
      </Section>

      {/* CORE VALUES Dark*/}
      <Section
        image={dark}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={homeValueHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={homeValueEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <CardList
          data={value}
          gridTemplateColumns={isTab ? "repeat(1, 1fr)" : "repeat(2, 1fr)"}
          textFontSize={isTab ? "0.9rem" : "1rem"}
          margin={isTab ? "1.25rem" : "2.5rem"}
        />
        <ButtonBar
          buttons={teamButtons}
          width={isTab ? "75%" : "37.5%"}
          gap={isTab ? "0.75rem" : "2rem"}
        />
      </Section>

      {/* COMPETENCES Light*/}
      <Section
        image={light}
        color={customColour.black}
        backgroundColor={customColour.lightBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
        borderBottom={`1.5px solid ${customColour.darkBackground}`}
      >
        <Heading
          heading={homeCompetenciesHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={homeCompetenciesEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <Slider
          slides={competences}
          aspectRatio={isTab ? 1 / 1 : 3 / 1}
          titleFontSize={isTab ? "1.25rem" : "2.5rem"}
          textFontSize={isTab ? "0.9rem" : "1rem"}
        />
        <ButtonBar
          buttons={servicesButtons}
          width={isTab ? "75%" : "37.5%"}
          gap={isTab ? "0.75rem" : "2rem"}
          background="linear-gradient(
            to right bottom,
            rgba(0, 0, 0, 0.9),
            rgba(0, 0, 0, 0.7)
            )"
        />
      </Section>

      {/* CLIENTELE Light*/}
      <Section
        color={customColour.black}
        backgroundColor={customColour.lightBackground}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Heading
          heading={homeClientHeading}
          fontSize={isTab ? "1.25rem" : "3rem"}
          fontweight={isTab ? "400" : "200"}
        />
        <Essay
          paragraphs={homeClientEssay}
          textAlign={isTab ? "left" : "justify"}
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <LogoSlider logos={logos} />
      </Section>

      {/* CONCLUSION Dark*/}
      <Section
        image={dark}
        width={isTab ? "90%" : "60%"}
        padding={isTab ? "2.5rem" : "5rem"}
      >
        <Essay
          paragraphs={homeConclusionEssay}
          textAlign="center"
          fontSize={isTab ? "0.9rem" : "1rem"}
        />
        <ButtonBar
          buttons={endButtons}
          width={isTab ? "75%" : "37.5%"}
          gap={isTab ? "0.75rem" : "2rem"}
        />
      </Section>
    </>
  );
};

export default GroupHome;
